import React from 'react'
import "./Terms_and_condition.css"
import Policy_banner from '../common_component/policy_banner/Policy_banner'
import Sumbit_btn from '../common_component/common_btn/submit_btn/Sumbit_btn';
import Cancle_btn from '../common_component/common_btn/cancle_btn/Cancle_btn';

function Terms_and_condition() {
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "TERMS AND CONDITIONS", link: "", isActive: true },
    ];

    return (
        <>
            <Policy_banner breadcrumbs={breadcrumbs} headingText="TERMS AND CONDITIONS" imgSrc="/assets/images/policy_banner/terms_and_condition/terms_and_condition_banner.png"/>
            <div className="container">
                <div className="content_holder">
                    <div className="text_holder">
                        <p>
                            Welcome to Ayansh International Trading FZ-LLC. By accessing our website or doing business with us, you agree to comply with and be bound by the following terms and conditions.
                        </p>
                    </div>
                    <div className="list_holder">
                        <ul>
                            <li>
                                <div className='text_holder'>
                                    <h6>1. Company Information</h6>
                                    <p>Ayansh International Trading FZ-LLC is a registered company in the United Arab Emirates, operating under applicable laws and regulations.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>2. Ordering Process</h6>
                                    <p>All content on this website is for informational purposes only.</p>
                                    <p>You agree not to misuse, duplicate, or distribute any content without written permission.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>3. Use of Website</h6>
                                    <p>All content on this website is for informational purposes only.</p>
                                    <p>You agree not to misuse, duplicate, or distribute any content without written permission.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>4. Orders & Payments</h6>
                                    <p>All orders are subject to acceptance and availability.</p>
                                    <p>Prices are quoted in USD or AED unless otherwise stated.</p>
                                    <p>Payment terms will be communicated prior to confirmation.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>5. Shipping & Delivery</h6>
                                    <p>Delivery timelines vary based on location and product availability.</p>
                                    <p>We are not liable for delays due to third-party logistics or customs.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>6. Returns & Refunds</h6>
                                    <p>Returns are accepted only in case of damaged or incorrect products.</p>
                                    <p>Claims must be made within 7 days of receiving the order.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>7. Limitation of Liability</h6>
                                    <p>We are not liable for any direct, indirect, or consequential loss arising from the use of our services or products.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>8. Governing Law</h6>
                                    <p>Returns are accepted only in case of damaged or incorrect products.</p>
                                    <p>Claims must be made within 7 days of receiving the order.</p>
                                </div>
                            </li>
                            <li>
                                <div className='text_holder'>
                                    <h6>9. Contact Us</h6>
                                    <p>We are not liable for any direct, indirect, or consequential loss arising from the use of our services or products.</p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className='btn_holder'>

                        <Cancle_btn btnText="Decline"  />
                        <Sumbit_btn btnText="Accept"  />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Terms_and_condition;
